import React from 'react';
import styled from '@emotion/styled';
import 'external-svg-loader';

import { Config, StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const BackgroundPatternContainer = styled.div({
  position: 'absolute',
  overflow: 'hidden',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
});

const BackgroundPatternSvg = styled.svg(props => ({
  color: 'var(--color-dark)',
  position: 'absolute',
  left: '40%',
  top: pxToRem(176),
  opacity: props.opacity ?? 0.05,
  transform: 'translate(-50%, -50%) rotate(-130deg) scale(4.3)',
  width: pxToRem(280),
  height: pxToRem(1400),

  [mqBreakpoints.tablet]: {
    transform: 'translate(-50%, -50%) rotate(-130deg) scale(3.3)',
    left: '46%',
    top: pxToRem(544),
    width: pxToRem(320),
    height: pxToRem(1600),
  },

  [mqBreakpoints.desktop]: {
    transform: 'translate(-50%, -50%) rotate(-130deg) scale(4.5)',
    left: '39%',
    top: pxToRem(0),
    width: pxToRem(800),
    height: pxToRem(2560),
  },
}));

export const BenefitsBackgroundPattern: React.FC = () => {
  return (
    <>
      <BackgroundPatternContainer>
        <BackgroundPatternSvg data-src={`${Config.get('image_cdn_base_url')}/ui/product-marketplace-webapp/vertical-pattern.svg`} />
      </BackgroundPatternContainer>
    </>
  );
};
